import Vue from 'vue'
// import { login, getInfo, logout, sabreLogin } from '@/api/login'
import { login, logout } from '@/api/login'
// eslint-disable-next-line no-unused-vars
import { getMyInfo } from '@/api/api-adminer'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    sabreAuthToken: '',
    roles: [],
    info: {},
    permissions: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      console.debug(`### SET_TOKEN=${token}`)
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    SetAccessToken: function ({ commit }, newToken) {
      Vue.ls.set(ACCESS_TOKEN, newToken, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TOKEN', newToken)
    },
    // 登录
    Login: function ({ commit }, userInfo) {
      const password = userInfo.password
      const username = userInfo.username
      // 调用login
      return new Promise((resolve, reject) => {
        login({ 'username': username, 'password': password })
          .then(res => {
            if (res.success) {
              Vue.ls.set(ACCESS_TOKEN, res.data.accessToken, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', res.data.accessToken)
              resolve(res)
            } else {
              // reject(new Error(`${res.errorCode}-${res.errorMessage}`))
              // 交由业务方法进行提示
              resolve(res)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
      // return new Promise((resolve, reject) => {
      //   login(userInfo).then(response => {
      //     Vue.ls.set(SABRE_AUTH_TOKEN, sabreAuthResponse.data.accessToken, 7 * 24 * 60 * 60 * 1000)
      //     commit('SET_SABRE_AUTH_TOKEN', sabreAuthResponse.data.accessToken)
      //     // 调用mock login
      //     const result = response.result
      //     Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
      //     commit('SET_TOKEN', result.token)
      //     resolve()
      //   }).catch(error => {
      //     reject(error)
      //   })
      // })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getMyInfo().then(response => {
          // 自定义后的代码
          if (!response.success) {
            reject(new Error('getMyInfo: Read Login userInfo fail !'))
          }
          const userInfo = response.data
          const roles = userInfo.roles
          var permissionsCodeArray = []
          if (roles && roles.length > 0) {
            roles.map(role => {
              permissionsCodeArray.push(role.code)
              if (role.permissions && role.permissions.length > 0) {
                role.permissions.forEach(per => {
                  permissionsCodeArray.push(per.code)
                })
              }
            })
            commit('SET_ROLES', roles) // 角色信息
            commit('SET_INFO', userInfo) // 用户信息
            commit('SET_PERMISSIONS', permissionsCodeArray) // 权限列表

            commit('SET_NAME', { name: userInfo.userName, welcome: welcome() })
            commit('SET_AVATAR', '/avatar2.jpg')
            response.permissionsList = permissionsCodeArray
            resolve(response)
          }

          // 修改前的代码
          // const result = response.result
          // if (result.role && result.role.permissions.length > 0) {
          //   const role = result.role
          //   role.permissions = result.role.permissions
          //   role.permissions.map(per => {
          //     if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
          //       const action = per.actionEntitySet.map(action => { return action.action })
          //       per.actionList = action
          //     }
          //   })
          //   role.permissionList = role.permissions.map(permission => { return permission.permissionId })
          //   commit('SET_ROLES', result.role)
          //   commit('SET_INFO', result)
          // } else {
          //   reject(new Error('getInfo: roles must be a non-null array !'))
          // }

          // commit('SET_NAME', { name: result.name, welcome: welcome() })
          // commit('SET_AVATAR', result.avatar)

          // resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        Vue.ls.remove(ACCESS_TOKEN)

        commit('SET_PERMISSIONS', [])

        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
